<template>
  <div class="container">
  	<div class="button">
      <i class="icon far fa-comment" @click="openModal" aria-hidden="true"></i>
  	</div>
    <CommentModal
      v-if="showCommentModal"
      :post="post"
      :model="model"
      @cancel="showCommentModal=false"
    />
    <RequireLoginModal 
      v-if="showRequiredLoginModal" 
      @cancel="showRequiredLoginModal=false" 
    />
  </div>
</template>
<script>
import CommentModal from "./Modal";
import RequireLoginModal from "../RequireLoginModal";

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showRequiredLoginModal: false,
      showCommentModal: false,
    };
  },
  components: { 
    CommentModal,
    RequireLoginModal,
  },
  methods: {
    openModal() {
      if (!this.$auth.check()) {
        this.showRequiredLoginModal = true;
        return;
      }
      
      this.showCommentModal = true;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../styles/variables";

.container {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  margin-block: unset;
}

.button {
  position: relative;
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
  font-weight: bold;
}

.icon {
  position: relative;
  font-size: 27px;
  vertical-align: bottom;

  top: 0px;
  // Image
  width: 28px;
  height: 28px;
  color: #858585;
  // background-size: cover;
  // background-repeat: no-repeat;
  // background-position: center;
  // background-image: url("/img/btn/heart.png");
}


// @media (hover: hover) {
//   .icon:hover {
//     background-image: url("/img/btn/heart-red.png") !important;
//   }
// }

// .icon.active {
//   background-image: url("/img/btn/heart-red.png");
// }
</style>
